import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { TimeService, TimeDataType } from '../../services/time.service';
import { ContextService } from '../../services/context.service';
import { SliderModule } from 'primeng/primeng';

@Component({
  selector: 'app-time-bar',
  templateUrl: './time-bar.component.html',
  styleUrls: ['./time-bar.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class TimeBarComponent implements OnInit {

  minTimeValue: number;
  maxTimeValue: number;
  timeData: TimeDataType;
  timeValue: number;
  @ViewChild('slider') slider: SliderModule;
  minTimeLabel: string;
  maxTimeLabel: string;
  timeLabel: string;

  constructor(private time: TimeService, private app: ContextService) { this.timeValue = -1; }

  async ngOnInit() {
    const t = await this.time.get();
    this.timeData = t;
    this.minTimeValue = t.values[0];
    this.minTimeLabel = t.labels[0];
    this.maxTimeValue = t.values[t.values.length - 1];
    this.maxTimeLabel = t.labels[t.labels.length - 1];
    this.timeValue = 0; // t.values[Math.round(t.values.length / 2)];
    // console.log(this.slider);
    // (<any>this.slider).writeValue(this.timeValue);
    // (<any>this.slider).updateDomData();
    this.time.current = {
      value: this.timeValue,
      label: this.timeData.labels[this.timeValue],
      valueMap: this.timeData.valueMap[this.timeValue]
    };
    this.timeLabel = this.timeData.labels[this.timeValue];
  }


  sliderMoved(event: any) {
    if (event.value !== this.timeValue) {
      this.timeValue = event.value;
      this.time.current = {
        value: this.timeValue,
        label: this.timeData.labels[this.timeValue],
        valueMap: this.timeData.valueMap[this.timeValue]
      };

      this.timeLabel = this.timeData.labels[this.timeValue];
      this.app.timeChanged();
    }
  }


}



// WEBPACK FOOTER //
// /Users/sofos/projects/anadigit/kounoupia-frontend/src/app/components/time-bar/time-bar.component.ts